var GetLastAppendedChildren = function () {
    return this.lastAppendedChildren;
}

export default GetLastAppendedChildren;